import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export const zoomPhoneUsersQuery = graphql(`
  query ZoomPhoneUsers {
    zoomPhoneUsers {
      id
      name
      email
      extension_number
      extension_id
      status
      user {
        id
        name
        primary_email
      }
    }
  }
`);

export type ZoomPhoneUserItem = ResultOf<
  typeof zoomPhoneUsersQuery
>["zoomPhoneUsers"][number];

export const zoomPhoneStaffQuery = graphql(`
  query ZoomPhoneStaff($first: Int!) {
    organisationMembers(first: $first) {
      data {
        id
        user {
          id
          name
          primary_email
        }
      }
    }
  }
`);

export const linkZoomPhoneUserMutation = graphql(`
  mutation LinkZoomPhoneUser(
    $zoom_user_id: String!
    $extension_id: String
    $user_id: ID
  ) {
    linkZoomPhoneUser(
      zoom_user_id: $zoom_user_id
      extension_id: $extension_id
      user_id: $user_id
    )
  }
`);

export const matchZoomPhoneUsersByEmailMutation = graphql(`
  mutation MatchZoomPhoneUsersByEmail {
    matchZoomPhoneUsersByEmail {
      linked
      unchanged
      unmatched
    }
  }
`);
